import { render, staticRenderFns } from "./TheActivityItem.vue?vue&type=template&id=2e3305ec&scoped=true"
import script from "./TheActivityItem.vue?vue&type=script&lang=js"
export * from "./TheActivityItem.vue?vue&type=script&lang=js"
import style0 from "./TheActivityItem.vue?vue&type=style&index=0&id=2e3305ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3305ec",
  null
  
)

export default component.exports